import styled, { css } from 'styled-components'

import {
    FlexCentered,
    AbsolutePositioning,
} from 'components/common/genericStyles'

import { assetsBase, colors, tabDesktopBreakpoint } from '../constants'

export const Container = styled.div`
    ${FlexCentered}
    justify-content: space-between;
    padding: 20px;
    background: ${colors.primaryWhite};
    border-radius: 8px;
    position: relative;
    width: 100%;
`

export const SelectionBackground = styled.div`
    ${AbsolutePositioning}
    margin: unset;
    opacity: 0.1;
    border-radius: inherit;
    ${props => {
        const {
            $isCorrect,
            $isTeacher,
            $totalParticipants,
            $numParticipantsSelected,
        } = props
        let width = $isTeacher
            ? ($numParticipantsSelected / $totalParticipants) * 100
            : 100
        width = isNaN(width) ? 0 : width
        const bgColor = $isCorrect ? colors.primaryGreen : colors.primaryRed
        return css`
            width: ${width}%;
            background: ${bgColor};
        `
    }};
`

export const ContentContainer = styled.div`
    ${FlexCentered}
    justify-content: space-between;
    flex-grow: 1;
`

export const LeftContainer = styled.div`
    display: flex;
`

export const RightContainer = styled.div`
    display: flex;
`

export const OptionName = styled.span`
    ${FlexCentered}
    ${props => {
        const { $isCorrect, $isTeacher } = props
        const fontColor = $isCorrect ? colors.primaryGreen : colors.primaryRed

        const icon = $isCorrect ? 'correct.svg' : 'incorrect.svg'
        const iconStyles =
            !$isTeacher &&
            css`width: 40px;
                flex: 0 30%;
                background-image: url('${assetsBase}/${icon}');
                background-position-y: center;
                background-repeat: no-repeat;
                /* Tablets & up */
                @media (min-width: ${tabDesktopBreakpoint}px) {
                    flex: unset;
                }
                `

        return css`
            ${iconStyles}
            span {
                color: ${fontColor};
                display: ${!$isTeacher && 'none'};
            }
        `
    }}
`

export const ChoiceContent = styled.div`
    margin: 0 20px;
    span {
        font-size: 14px;
    }

    /* Tablets & up */
    @media (min-width: ${tabDesktopBreakpoint}px) {
        span {
            font-size: 18px;
        }
    }
`

export const Participants = styled.div`
    width: 35px;
    height: 35px;
    ${FlexCentered}
`

export const textStyles = css`
    font-size: 18px;
    line-height: 25px;
    margin-bottom: 2.22vh;
    @media only screen and (orientation: landscape) {
        margin-top: 1vh;
    }

    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        font-size: 32px;
        line-height: 44px;
        margin-top: 0;
    }
`
